import { useVoice } from "../context/voice/VoiceContext"
import Button from "../formfields/Button"


type Props = {

}

function VoiceModeToggle({ }: Props) {


    const {
        isListening,
        isRecognizerRunning,
        speechRecognitionSupported,
        startListening,
        stopListening,
        isListeningEnabled,
        setIsListeningEnabled
    } = useVoice()


    if (!speechRecognitionSupported()) {
        return null
    }


    return <Button
        onClick={() => {
            if (isListeningEnabled) {
                setIsListeningEnabled(false)
                localStorage.setItem('savedVoiceOption', 'no')
            } else {
                setIsListeningEnabled(true)
                localStorage.setItem('savedVoiceOption', 'yes')
            }
        }}
        text={isListeningEnabled ? 'Disable voice mode' : 'Enable voice mode'}
        variant={isListeningEnabled ? `white` : `primary`}
        align={'left'}
        size={'big'}
    />

}

export default VoiceModeToggle